export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        if (typeof binding.value === 'function') {
          binding.value(event)
        }
      }
    }
    document.addEventListener('click', el.clickOutsideEvent)
    document.addEventListener('touchstart', el.clickOutsideEvent)
  },
  
  unmounted(el) {
    if (el.clickOutsideEvent) {
      document.removeEventListener('click', el.clickOutsideEvent)
      document.removeEventListener('touchstart', el.clickOutsideEvent)
      delete el.clickOutsideEvent
    }
  }
}
